import { Rule, HTMLarkdownOptions, PassDownOptions, FilterPredicate } from 'htmlarkdown';

const REFERENCES_CLASS = 'referencesStack';

export const referencesFilter: FilterPredicate = (element: Element): boolean => {
    return element.classList.contains(REFERENCES_CLASS);
};

export const referenceRule: Rule = {
    filter: [referencesFilter],
    replacement: (_element: Element, _options: HTMLarkdownOptions, _parentOptions: PassDownOptions): string => {
        return '';
    }
};
